import * as React from 'react';
import { useState } from "react";
import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import { Button, Checkbox, FormGroup, TextField, Divider, FormHelperText } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import ProgressBar from "./ProgressBar"
import Chip from '@mui/material/Chip';
import { uploadCoverApi } from "../../../../../services/subtitlesApi"
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import ImageSearchIcon from '@mui/icons-material/ImageSearch';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  customToastify,
  checkErrorMessage,
  checkResponseData,
} from "../../../utils/utilsFunctions";
import Box from "@mui/material/Box";
import CoverSearchResult from "./CoverSearchResult/CoverSearchResult"
import { findeCoverApi } from "../../../../../services/subtitlesApi"
const SERVER_URL = `${process.env.REACT_APP_SITEURL}`;

export default function ModalSelectCover(props) {
  const { modalSelectCover, handleModalSelectCover, nameOfMovie } = props
  const [coverUploadPercent, setCoverUploadPercent] = useState(0);
  const [coverList, setCoverList] = useState([]);
  const [movieName, setMovieName] = useState("");

  const selectCover = (coverUrl) => {
    handleModalSelectCover(coverUrl)
  }

  const handleMovieName = (name) => {
    setMovieName(name)
  }

  const handlecoverUploadPercent = (percent) => {
    setCoverUploadPercent(percent * 100)
  }

  const uploadCover = async (coverFile) => {
    let toastMsg = toast.loading("لطفا صبر کنید...")
    try {
      let formData = new FormData();
      formData.append("coverFile", coverFile);
      formData.append("nameOfMovie", nameOfMovie);
      let response = await uploadCoverApi(formData, handlecoverUploadPercent);;
      const resData = checkResponseData(response);
      if (resData["success"]) {
        selectCover(`${SERVER_URL}/subtitles/covers/${resData["data"]["data"][0]["fileName"]}`)
        toast.update(toastMsg, { render: resData["message"] || "درخواست انجام شد", type: "success", isLoading: false, autoClose: 3000 });
        setCoverUploadPercent(0)
      } else {
        toast.update(toastMsg, { render: resData["message"] || "اتفاق غیر منتظره پیش آمده است", type: "info", isLoading: false, autoClose: 3000 });
        setCoverUploadPercent(0)

      }
    } catch (error) {
      const errData = checkErrorMessage(error);
      let errMsg = errData["titles"] || errData["message"]
      toast.update(toastMsg, { render: errMsg || "مشکلی وجود دارد", type: "error", isLoading: false, autoClose: 3000 });
      console.error(error);
      setCoverUploadPercent(0)
    }
  }

  const searchCovers = async (data, paginate) => {
    try {
      if (!movieName) {
        customToastify("error", "نام فیلم را وارد کنید")
      } else {
        // setSearchClick(true)
        // setSubtitlesList(false)
        let response = await findeCoverApi({ nameOfMovie: movieName }, { page: 1, perPage: 50 });
        const resData = checkResponseData(response);

        if (resData["success"]) {
          // setSearchClick(false)
          setCoverList(resData["data"]["docs"])

          // toast.update(toastMsg, { render: resData["message"] || "درخواست انجام شد", type: "success", isLoading: false, autoClose: 3000 });
        } else {
          // toast.update(toastMsg, { render: resData["message"] || "اتفاق غیر منتظره پیش آمده است", type: "info", isLoading: false, autoClose: 3000 });
          setCoverList([])
        }

      }
    } catch (error) {

      const errData = checkErrorMessage(error);
      let errMsg = errData["titles"] || errData["message"]
      console.log("errData,", errMsg)
      setCoverList([])
      // toast.update(toastMsg, { render: errMsg || "مشکلی وجود دارد", type: "error", isLoading: false, autoClose: 3000 });
      // console.error(error);
      customToastify("error", errMsg)
      // setSearchClick(false)
    }
  }

  React.useEffect(() => {
    setMovieName(nameOfMovie)
  }, [nameOfMovie])

  return (
    <Dialog
      fullScreen={true}
      open={modalSelectCover}
    >
      <DialogContent>
        <Divider textAlign="left"><Chip label="آپلود کاور" size="small" /></Divider>
        <Paper
          component="form"
          sx={{ p: '2px 4px', m: "auto", display: 'flex', alignItems: 'center' }}
        >
          <Button
            variant="contained"
            component="label"
            sx={{ m: 0.5 }}
          >
            {/* {subtitleFileName.length > 0
                            ? subtitleFileName.slice(
                                subtitleFileName.length - 20,
                                subtitleFileName.length
                              )
                            : "انتخاب زیرنویس (SRT)"} */}
            <input
              hidden
              id="subtitles"
              name="subtitles"
              type="file"
              onChange={(event) => {
                if (event.target.files[0]) {
                  uploadCover(event.target.files[0]);
                  // console.log("123", event.target.files[0].name);
                  // setSubtitleFileName(event.target.files[0].name);
                  // handleSubtitleFileName(
                  //   "one",
                  //   false,
                  //   event.target.files[0]
                  // );
                }
              }}
            />
            آپلود
            <AddPhotoAlternateIcon sx={{ mx: 1 }} />
          </Button>
          {coverUploadPercent > 0 ? <ProgressBar percent={coverUploadPercent} /> : null}
        </Paper>
        <Divider textAlign="left"><Chip label="انتخاب از کاور های موجود" size="small" /></Divider>
        <Paper
          component="form"
          sx={{ p: '2px 4px', m: "auto", display: 'flex', alignItems: 'center' }}
        >
          <IconButton sx={{ p: '10px' }} aria-label="menu">
            <MenuIcon />
          </IconButton>
          <InputBase
            value={movieName}
            sx={{ ml: 1, flex: 1 }}
            placeholder='نام فیلم یا سریال'
            inputProps={{ 'aria-label': 'نام فیلم یا سریال' }}
            onChange={(e) => { handleMovieName(e.target.value) }}
          />
          <Button onClick={() => { searchCovers() }} variant="contained" type="button" sx={{ p: '10px' }} aria-label="search">
            جست و جو
            <ImageSearchIcon sx={{ mx: 1 }} />
          </Button>
        </Paper>
        <Box sx={{ p: 1 }}>
          <CoverSearchResult coverList={coverList} handleModalSelectCover={handleModalSelectCover} />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button sx={{ m: 1 }} onClick={() => { handleModalSelectCover(false) }} variant="contained" color="warning" >بستن</Button>
      </DialogActions>
    </Dialog>
  );
}